import RootModal, { RootModalProps } from "@/components/RootModal/RootModal";
import useTranslation from "@/hooks/useTranslation";
import { Form, Input, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { useNavigate } from "react-router-dom";
import { useAddGoodsAndServicesItem } from "../useGoodsAndServices";

export default function AddGoodsAndServicesItem(props: RootModalProps) {
  const addGoodsAndServicesItem = useAddGoodsAndServicesItem();
  const navigate = useNavigate();
  const [form] = useForm<{ name: string }>();
  const t = useTranslation();

  const onSubmit = () => {
    form
      .validateFields()
      .then((x) => {
        addGoodsAndServicesItem
          .mutateAsync({ name: x.name })
          .then(({ data: goodsAndServicesItem }) => {
            message.success("Good or service has been created.");
            navigate("/goods_and_services/" + goodsAndServicesItem.id);
          })
          .catch(() => message.error(t.errors.general));
      })
      .catch(() => message.error("Enter a name to create a new good or service."));
  };

  return (
    <RootModal
      {...props}
      title="Add good or service"
      okButtonProps={{ onClick: onSubmit }}
      okText="Add"
    >
      <Form
        form={form}
        onKeyUp={(e) => {
          if (e.code === "Enter") onSubmit();
        }}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input type="text" />
        </Form.Item>
      </Form>
    </RootModal>
  );
}
